import { render, staticRenderFns } from "./BasketSettingsFilter.vue?vue&type=template&id=a8c2f9e8&"
import script from "./BasketSettingsFilter.vue?vue&type=script&lang=js&"
export * from "./BasketSettingsFilter.vue?vue&type=script&lang=js&"
import style0 from "./BasketSettingsFilter.vue?vue&type=style&index=0&id=a8c2f9e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports